/*eslint node/no-process-env: "off"*/

import device from "current-device";


export default class Env {
    //
    // Development/production modes
    //
    static readonly nodeEnv = process.env.NODE_ENV;
    static readonly isDev = process.env.NODE_ENV === 'development';
    static readonly isProd = !Env.isDev;

    /*
    //
    // Convenience functions
    //
    static getOption(name: string, def: string): string {
        let val = process.env[name];
        return val ?? def;
    }

    static requireOption(optName: string): string {
        let val = process.env[optName];
        assertNotEmpty(val, `.env missing: ${optName}`);
        return val!;
    };

    static requireAppOption(optName: string): string {
        return Env.requireOption("REACT_APP_" + optName);
    }
    */


    // 
    // Device information
    //
    static readonly isMobile = device.mobile();
    static readonly isDesktop = device.desktop();
    static readonly isTablet = device.tablet();

    static readonly isLandscape = device.landscape();
    static readonly isPortrait = device.portrait();
};
